export default __webpack_public_path__ + "static/10.03-4-4466be27df7982c7446b9871b516d81d.png";